export default "__VITE_ASSET__BcCmP4GX__"